import { render, staticRenderFns } from "./purrfqquotation.vue?vue&type=template&id=2fa84a7b&scoped=true&"
import script from "./purrfqquotation.vue?vue&type=script&lang=js&"
export * from "./purrfqquotation.vue?vue&type=script&lang=js&"
import style0 from "./purrfqquotation.vue?vue&type=style&index=0&id=2fa84a7b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa84a7b",
  null
  
)

export default component.exports